import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { CompaniesService } from '../../../../components/crm/companies/pages/companies/companies.service';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-priority-renderer',
  templateUrl: './priority-renderer.component.html',
  styleUrls: ['./priority-renderer.component.scss']
})
export class PriorityRendererComponent implements OnInit, ICellRendererAngularComp {
  params: any;
  isActive: boolean = false;
  isAddRFQIcons: boolean = false;
  isAlreadyInRFQ: boolean = false;
  isDateFormat: boolean = false;

  constructor(public companiesService: CompaniesService,) { }

  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
    this.isActive = !!params.data?.priorityConfirmed;
    this.isAddRFQIcons = !!params?.colDef?.cellRendererParams?.isAddRFQIcons;
    this.isDateFormat = !!params?.colDef?.cellRendererParams?.dateFormat;
    const disabledParam = params?.colDef?.cellRendererParams?.isAlreadyInRFQ;
    this.isAlreadyInRFQ = typeof disabledParam === 'function' ? disabledParam(params) : !!disabledParam;
  }
  refresh(params: ICellRendererParams<any, any>): boolean {
    return false
  }

  ngOnInit(): void {
  }

  changeRoute(params:any) {
    this.onClick(params)
  }  

  onClick(params?: any) {
    const customEvent = new CustomEvent('textCellClick', {
      detail: { data: this.params },
    });
    document.dispatchEvent(customEvent);
  }

  onToggleChange(isActive: boolean) {
    this.isActive = isActive;
  }

  ngOnDestroy() {
  }

  onPriorityClick() {
    if (this.isActive) return;
    const customEvent = new CustomEvent('confirmPriorityQty', {
      detail: { data: this.params.data }
    });
    document.dispatchEvent(customEvent);
  }
  
  onAddRemoveRFQClick(event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();
    const eventName = this.isAlreadyInRFQ === true ? 'removeRFQClick' : 'addRFQClick';
    const customEvent = new CustomEvent(eventName, {
      detail: { data: this.params}
    });
    document.dispatchEvent(customEvent);
  }
}
